import { createContext } from 'react';
import { SelectContextValue } from './types';
export const SelectContext = createContext({} as SelectContextValue);
